 
import { getColor } from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import { useRef } from 'react';
import type ReactEChartsCore from 'echarts-for-react/lib/core';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import Flex from '@/components/common/Flex';
import MainBarChart from '@/app/common/components/charts/BarChart';
import CustomLegent from '@/app/common/components/charts/CustomLegent';
import CardChartDropDown from '@/components/common/CardChartDropDown';

interface CrawlHistoryRow {
  host_name: string;
  count_page_internal_total?: number | null;
  count_page_external_total?: number | null;
}

interface CrawlBarCardPagesProps {
  data: CrawlHistoryRow[];
  isLoading: boolean;
}

// نمودار صفخات خزش شده در تاریخچه
const CrawlBarCardPages = ({ data }: CrawlBarCardPagesProps) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const series = [
    {
      name: 'صفحات داخلی',
      data: data
        .filter(({ count_page_internal_total }) => count_page_internal_total)
        .map(({ count_page_internal_total }) => ({
          value: count_page_internal_total
        })),
      itemStyle: {
        color: getColor('ourcolor-1')
      }
    },
    {
      name: 'صفحات خارجی',
      data: data
        .filter(({ count_page_external_total }) => count_page_external_total)
        .map(({ count_page_external_total }) => ({
          value: count_page_external_total
        })),
      itemStyle: {
        color: getColor('ourcolor-2'),
        borderRadius: [3, 3, 0, 0]
      }
    }
  ];
  return (
    <Card className="h-100" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            صفحات خزش شده
            <HelpTooltip html={crawlTooltip.crawlerHistory.crawled_pages} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-3"
      >
        <MainBarChart
          chartRef={chartRef}
          height={250}
          categories={data
            .filter(
              ({ count_page_internal_total }) => count_page_internal_total
            )
            .map(item => item.host_name)}
          series={series}
        />
      </Card.Body>
      <div className="d-flex mt-n4 mb-3 gap-2 justify-content-center pt-1 align-items-center">
        {series.map(item => (
          <CustomLegent
            key={item.name}
            name={item.name}
            chartRef={chartRef}
            color={item.itemStyle.color}
          />
        ))}
      </div>
    </Card>
  );
};
export default CrawlBarCardPages;
